import { Button } from '@components/Button';
import { IconAdd } from '@components/icons';
import styles from './PageHeader.module.scss';

export interface PageHeaderProps {
  /** Page title */
  title: string;

  /** Show primary action button */
  showPrimaryAction?: boolean;

  /** Primary action button text */
  primaryActionText?: string;

  /** Primary action click handler */
  onPrimaryAction?: () => void;

  /** Primary action button icon */
  primaryActionIcon?: React.ReactNode;

  /** Show secondary action button */
  showSecondaryAction?: boolean;

  /** Secondary action button text */
  secondaryActionText?: string;

  /** Secondary action click handler */
  onSecondaryAction?: () => void;

  /** Secondary action button icon */
  secondaryActionIcon?: React.ReactNode;

  /**
   * Custom action slot. When provided, replaces the built-in primary/secondary
   * action buttons entirely — use it to embed a custom trigger such as a
   * dropdown menu (SC-2192).
   */
  actionSlot?: React.ReactNode;
}

export const PageHeader = ({
  title,
  showPrimaryAction = true,
  primaryActionText = 'Add New Type',
  onPrimaryAction,
  primaryActionIcon = <IconAdd size={14} />,
  showSecondaryAction = false,
  secondaryActionText,
  onSecondaryAction,
  secondaryActionIcon = <IconAdd size={14} />,
  actionSlot,
}: PageHeaderProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <div className={styles.actions}>
        {actionSlot ?? (
          <>
            {showSecondaryAction && (
              <Button
                variant="secondary"
                size="small"
                leadingIcon={secondaryActionIcon}
                onClick={onSecondaryAction}
                className={styles.actionButton}
              >
                {secondaryActionText}
              </Button>
            )}
            {showPrimaryAction && (
              <Button
                variant="primary"
                size="small"
                leadingIcon={primaryActionIcon}
                onClick={onPrimaryAction}
                className={styles.actionButton}
              >
                {primaryActionText}
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
